import ContentWrap from './ContentWrap'

export default ContentWrap